import 'core-js/stable';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueI18n from 'vue-i18n';
import router from '@router/router';
import store from '@store/store';
import { applicationMixin } from '@store/mixins';
import App from './App.vue';
import './globalComponents';

Vue.use(VueCookies);
Vue.use(VueI18n);
Vue.mixin(applicationMixin);
Vue.config.productionTip = false;

// Load all locales and remember context
function loadMessages() {
  const context = require.context('./i18n/locales', true, /[a-z0-9-_]+\.json$/i);

  const messages = context
    .keys()
    .map(key => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
    .reduce(
      (messages, { key, locale }) => ({
        ...messages,
        [locale]: context(key),
      }),
      {},
    );

  return { context, messages };
}

const { context, messages } = loadMessages();

const i18n = new VueI18n({
  locale: 'ru_RU',
  fallbackLocale: ['en_US', 'ru_RU'],
  messages,
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');


// Hot updates
if (module.hot) {
  module.hot.accept(context.id, () => {
    const { messages: newMessages } = loadMessages();

    Object.keys(newMessages)
      .filter(locale => messages[locale] !== newMessages[locale])
      .forEach((locale) => {
        messages[locale] = newMessages[locale];
        i18n.setLocaleMessage(locale, messages[locale]);
      });
  });
}
